import React, { useState } from "react";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { IoEyeOffOutline } from "react-icons/io5";
import { BsThreeDots } from "react-icons/bs";
import { useDashboard } from "../../context/DashboardContext";

const CreditAmount =() => {
  const [visible, setVisible] = useState(false);
  const {balance}=useDashboard();

  const toggleVisibility = () => {
    setVisible(!visible);
  };

  return (
    <div className="d-flex align-items-center justify-content-center gap-2">
      <span
        onClick={toggleVisibility}
        style={{ cursor: "pointer", fontSize: "16px" }}
      >
        {visible ? <IoEyeOffOutline /> : <MdOutlineRemoveRedEye />}
      </span>
       <span style={{ fontSize: "18px", fontWeight: "600" }}>
        {visible ? `USD ${balance}` : <BsThreeDots />}
      </span>
    </div>
  );
};

export default CreditAmount;